import React from "react";
import style from "./index.module.scss";
import { Button } from "antd";

interface ResourceEmptyProps {
    onClick: () => void;
}

export default function ResourceEmpty({ onClick }: ResourceEmptyProps) {
    return (
        <div className={style.root}>
            <Button className={style.btn} onClick={onClick}>
                请添加课件
            </Button>
        </div>
    );
}
